<app-modal [open]="open" [title]="title" (close)="onCancel()">
  <p class="text-sm text-gray-600">{{ message }}</p>
  <ng-content></ng-content>

  <div class="flex justify-end gap-2 pt-5">
    <button
      *ngIf="showCancel"
      type="button"
      (click)="onCancel()"
      [disabled]="loading"
      class="btn-outline disabled:opacity-50 disabled:cursor-not-allowed">
      {{ cancelLabel }}
    </button>
    <button
      type="button"
      (click)="onConfirm()"
      [disabled]="loading"
      [class.btn-primary]="variant === 'primary'"
      [class.btn-danger]="variant === 'danger'"
      class="flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">
      <lucide-icon *ngIf="loading" name="Loader2" [size]="16" class="animate-spin"></lucide-icon>
      {{ loading ? loadingLabel : confirmLabel }}
    </button>
  </div>
</app-modal>
